module.exports = __webpack_public_path__ + "img/bolts.46bb3868.svg";